export default __webpack_public_path__ + "static/Dosis-Regular-c914145c6264f6abfc8cdb0f0139bdc5.woff";